import httpClient from 'httpClient';
import { CONTENT_TYPE, MULTIPART_FORM_DATA } from './userService';

class EventService {
  static addEvent(celebrityId, event) {
    return httpClient.post(`/celebrities/${celebrityId}/events`, event, {
      headers: { [CONTENT_TYPE]: MULTIPART_FORM_DATA },
      transformRequest: () => event
    });
  }

  static getEventById(celebrityId) {
    return httpClient.get(`/celebrities/${celebrityId}/events`);
  }

  static startEventById(eventId) {
    return httpClient.post(`/celebrities/lives?event_id=${eventId}`);
  }

  static startLiveEvent(celebrityId, eventId) {
    return httpClient.put(`/celebrities/${celebrityId}/events/${eventId}/started`);
  }

  static stopLiveEvent(celebrityId, eventId) {
    return httpClient.put(`/celebrities/${celebrityId}/events/${eventId}/finished`);
  }

  static getAllEvents(eventType) {
    return httpClient.get(`/events?event_type=${eventType}`);
  }

  static deleteEvent(celebrityId, eventId) {
    return httpClient.delete(`/celebrities/${celebrityId}/events/${eventId}`);
  }

  static getEventByEventId(eventId, celebrityId) {
    return httpClient.get(`/celebrities/${celebrityId}/events/${eventId}`);
  }

  static updateEvent(celebrityId, eventId, event) {
    return httpClient.put(`/celebrities/${celebrityId}/events/${eventId}`, event, {
      headers: { [CONTENT_TYPE]: MULTIPART_FORM_DATA },
      transformRequest: () => event
    });
  }

  static reportEvent({ eventId, params }) {
    return httpClient.post(`/events/${eventId}/reported_contents`, params);
  }
}

export default EventService;
